import { IconButton, Stack, styled } from '@mui/material';
import { ThreadIcon } from '@schooly/style';
import { FC } from 'react';

type ThreadUnreadProps = {
  unread?: boolean;
};

export const ThreadUnread: FC<ThreadUnreadProps> = ({ unread }) => {
  return (
    <Stack>
      <UnreadButton sx={{ color: 'common.grey3' }} unread={!!unread}>
        <ThreadIcon />
      </UnreadButton>
    </Stack>
  );
};

export const UnreadButton = styled(IconButton)<{ unread: boolean }>(({ theme, unread }) => ({
  cursor: 'pointer',
  '&:after': unread
    ? {
        content: "''",
        display: 'block',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        background: theme.palette.success.main,
        border: '1px solid white',
        position: 'absolute',
        right: '-1px',
        top: '-2px',
      }
    : undefined,
}));
